import { Injectable } from '@angular/core';

import { SiteTypeEnum } from '../../enums';
import { StrategyAbstractService } from '../strategy-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class TiktokService extends StrategyAbstractService {
  constructor() {
    super();
  }

  getType(): number {
    return 21;
  }

  getTypeString(): string {
    return SiteTypeEnum.Tiktok;
  }

  getAllTasksTypes(): number[] {
    return this.getPublicTaskTypes();
  }

  getPublicTaskTypes(): number[] {
    return [47];
  }

  getTaskTypeString(taskType: number): string {
    const mapping = {
      47: 'tiktok/comments',
    };
    return mapping[taskType];
  }

  getTaskTypeQueueId(taskType: number): string {
    const mapping = {
      47: 'tiktok-comments',
    };
    return mapping[taskType];
  }

  isQuickReplyEnable() {
    return 0;
  }
}
